// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V16HK","questions":"styles_questions__1X2gO","footer":"styles_footer__Uisjk"};